import React from 'react';
import { useSelector } from 'react-redux';

import { EstateSizeIcon, PropertyTypeIcon, LocationIcon, BedroomsIcon, BedIcon, BathroomIcon } from '../infoIcons/InfoIcons';
import { InfoEntry } from '../infoEntry/InfoEntry';

export const Info = () => {
    const { estateSize, noOfBedrooms, noOfBeds, noOfBathrooms, propertyType, situation } = useSelector((state) => state.objectData);

    const entryData = [
        ['estateSize', { displayName: 'Størrelse', icon: EstateSizeIcon, value: estateSize }],
        ['noOfBedrooms', { displayName: 'Soverom', icon: BedroomsIcon, value: noOfBedrooms }],
        ['noOfBeds', { displayName: 'Sengeplasser', icon: BedIcon, value: noOfBeds }],
        ['noOfBathrooms', { displayName: 'Bad', icon: BathroomIcon, value: noOfBathrooms }],
        ['propertyType', { displayName: 'Boligtype', icon: PropertyTypeIcon, value: propertyType }],
        ['situation', { displayName: 'Beliggenhet', icon: LocationIcon, value: situation }],
    ];

    const renderListEntries = () => {
        const entries = [];
        for (const entry of entryData) {
            const name = entry[0];
            const { displayName, icon, value } = entry[1];

            if (!value) {
                continue;
            }

            entries.push(
                <InfoEntry key={`list-${name}`} description={displayName} value={value} Icon={icon} data-testid={`adInfo-${name}`} />
            );
        }

        return entries;
    };

    return (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-16" data-testid="adInfo">
            {renderListEntries()}
        </div>
    );
};
